import React, { useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Components
import LocationForm from '../../../../../components/forms/ActionForms/LocationForm';

// Constants
import { formActionValidationNaming } from '../../../../../components/forms/ActionForms/constants';

// Types
import { type LocationFormValues } from '../../../../../components/forms/ActionForms/LocationForm/types';
import { type WorkOrder } from '../../../../../types/workOrder';
import { OrderActionReferences } from '../types';
import { Role } from '../../../../../types/auth';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

export default function LocationActionFormPage(): JSX.Element {
  const { t } = useTranslation('validation');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as LocationFormValues &
    WorkOrder &
    OrderActionReferences & { parentExpeditionOrderStatus?: string };

  // Get current user role - RoomTeam can only view, not edit
  const { user } = useAuth();
  const isReadOnly = user?.user?.rolActive === Role.RoomTeam;

  const onFormSubmit = () => {
    if (isReadOnly) return; // RoomTeam cannot submit
    navigate('../edition');
  };

  useLayoutEffect(() => {
    dispatch(
      roidOTSelected('actions-validation', loaderData.roid, loaderData.orderId)
    );
  }, []);

  return (
    <LocationForm
      onFormSubmit={isReadOnly ? () => {} : onFormSubmit}
      initialData={loaderData}
      namingPersistForm={
        formActionValidationNaming.NEW_VALIDATION_LOCATION_FORM
      }
      textButton={isReadOnly ? t('viewOnly') : user?.user?.rolActive === Role.Tablet ? t('buttons:continue') : t('validate')}
    />
  );
}
